import { HelpArticle } from "@/components/HelpArticle/HelpArticle";
import { Screenshot } from "@/components/Screenshot/Screenshot";
import { createFileRoute } from "@tanstack/react-router";
import leggTilHjemmelserklæring from "./legg-til-hjemmelserklaering.png";
import kjøpesumSkifteoppgjør from "./kjopesum-skifteoppgjor.png";
import menyLeggTilVedlegg from "./meny-legg-til-vedlegg.png";
import vedleggskategori from "./vedleggskategori.png";
import kjøpesumUskifte from "./kjopesum-uskifte.png";

const title = "Dødsbo – hjemmelserklæring og hjemmelserklæring med uskifte";

export const Route = createFileRoute("/_authenticated-user/hjelp/dodsbo-hjemmelserklaering/")({
  head: () => ({
    meta: [{ title: `${title} | Alice & Bob` }],
  }),
  component: Page,
});

function Page() {
  return (
    <HelpArticle title={title}>
      <h2>Hjemmelserklæring</h2>
      <p>Her skal eiendommen overskjøtes fra avdød til arvingene.</p>

      <h3>Opprett hjemmelserklæring</h3>
      <p>Trykk på «Legg til dokument» og velg «Hjemmelserklæring».</p>
      <Screenshot
        src={leggTilHjemmelserklæring}
        width={345}
        alt="Menyen «Legg til dokument» åpen, med «Hjemmelserklæring» markert."
      />

      <p>
        Kjøpesum og salgsverdi/avgiftsgrunnlag er automatisk satt til <strong>kr 0</strong>, og omsetningstype og
        dokumentavgiftsgrunnlag er automatisk satt til <strong>skifteoppgjør</strong>.
      </p>
      <Screenshot
        src={kjøpesumSkifteoppgjør}
        width={900}
        alt="Seksjonene «Kjøpesum» og «Salgsverdi/avgiftsgrunnlag» med beløp kr 0, omsetningstype «Skifteoppgjør (6)» og dokumentavgiftsårsak «Skifteoppgjør (S)»."
      />

      <p>
        <strong>NB!</strong> Sørg for at kun avdød står under «erklæring om sivilstand».
      </p>

      <h3>Legg til skifteattest</h3>
      <p>
        Når dokumentet er opprettet og lagret, kan du trykke på de tre prikkene til høyre i dokumentet og velge «Legg
        til vedlegg».
      </p>
      <Screenshot
        src={menyLeggTilVedlegg}
        width={287}
        alt="Menyen bak de tre prikkene på dokumentet, med «Legg til vedlegg» markert."
      />

      <p>
        Last opp skifteattesten som vedlegg i kategorien{" "}
        <strong>«Skifteattest, uskifteattest og bostyrerattest ved dødsboskifte»</strong>.
      </p>
      <Screenshot
        src={vedleggskategori}
        width={287}
        alt="Dialogen «Last opp vedlegg» med nedtrekkslisten over vedleggskategorier åpen."
      />

      <p>
        <strong>NB!</strong> Dersom skifteattesten opplyser at det foreligger et testament, må testamentet også legges
        ved. Det må være påført inneståelseserklæring og stemplet med «Rett kopi».
      </p>

      <h2>Hjemmelserklæring med uskifte</h2>
      <p>Her skal eiendommen overskjøtes fra avdød til den som har overtatt boet i uskifte.</p>

      <h3>Opprett hjemmelserklæring</h3>
      <p>Trykk på «Legg til dokument» og velg «Hjemmelserklæring».</p>
      <Screenshot
        src={leggTilHjemmelserklæring}
        width={345}
        alt="Menyen «Legg til dokument» åpen, med «Hjemmelserklæring» markert."
      />

      <p>
        Kjøpesum og salgsverdi/avgiftsgrunnlag er automatisk satt til <strong>kr 0</strong>, og omsetningstype og
        dokumentavgiftsgrunnlag er automatisk satt til skifteoppgjør.{" "}
        <strong>Her må det endres til «uskifte» på både omsetningstype og dokumentavgiftsgrunnlag.</strong>
      </p>
      <Screenshot
        src={kjøpesumUskifte}
        width={900}
        alt="Seksjonene «Kjøpesum» og «Salgsverdi/avgiftsgrunnlag» med beløp kr 0, omsetningstype «Uskifte (5)» og dokumentavgiftsårsak «Uskifte (U)»."
      />

      <p>
        <strong>NB!</strong> Sørg for at kun avdød står under «erklæring om sivilstand».
      </p>

      <h3>Legg til uskifteattest</h3>
      <p>
        Last opp uskifteattesten som vedlegg i kategorien{" "}
        <strong>«Skifteattest, uskifteattest og bostyrerattest ved dødsboskifte»</strong>.
      </p>
    </HelpArticle>
  );
}
